<template>
    <div class="modal modal-open" id="modal-add-service-to-deal">
        <div class="modal-overflow">
            <div class="modal-window">
                <button type="button" class="btn btn-modal-close" @click="handleCloseModal">
                    <i class="icon icon-cancel"></i>
                </button>
                <div class="modal-body">
                    <div class="row jus-c--space-between">
                        <div class="col-xl-6 col-lg-6 col-md-6">
                            <div class="form-field form-field--modal form-field--tree">
                                <label for="service_id">Service<span class="red">*</span><span
                                        @click="toggleNewServiceModal" style="color: #ec4657">Add new
                                        service</span></label>
                                <treeselect v-model="deal_service.service_id" id="service_id" name="service_id"
                                    :multiple="true" :valueConsistsOf="'ALL'" :options="services_list"
                                    :clearOnSelect="true" />
                                <span class="error" style="left: 0" v-if="errors.service_id">{{ errors.service_id
                                    }}</span>
                            </div>
                        </div>
                        <div class="col-xl-5 col-lg-5 col-md-5">
                            <div class="form-field form-field--datepicker"
                                :style="diminishing ? 'margin-bottom: 8px' : ''" ref="datepicker">
                                <label for="kickoff_date">Kick-off date</label>
                                <input type="text" id="kickoff_date" v-model="deal_service.kick_off_date"
                                    name="kickoff_date" @changeDate="onChangeDatePicker" />
                                <button type="button" class="btn btn--icon">
                                    <i class="icon icon-calendar"></i>
                                </button>
                            </div>
                            <p v-if="diminishing" class="kick-off-diminishing">
                                Diminishing date:
                                {{ calculated_diminishing_date }}
                            </p>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-xl-12 col-lg-12 col-md-12">
                            <div class="form-field form-field--text">
                                <label for="custom_service">Custom service</label>
                                <input type="text" id="custom_service" v-model="deal_service.custom_service"
                                    name="custom_service" />
                                <span class="error" style="left: 0" v-if="errors.custom_service">{{
                                    errors.custom_service }}</span>
                            </div>
                        </div>
                    </div>
                    <div class="col-xl-12 col-lg-12 col-md-12">
                        <div class="form-field form-field--tree" style="margin-bottom: 24px">
                            <label for="service_id">SOW<span v-if="!is_draft" class="red">*</span></label>
                            <treeselect v-model="deal_service.sow_file" id="sow_file" name="sow_file" :multiple="false"
                                :options="sow_select_list" :clearOnSelect="true" />
                            <span class="error" style="left: 0" v-if="errors.sow_file">{{ errors.sow_file }}</span>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-xl-12 col-lg-12 col-md-12">
                            <div class="row" v-for="t in brand_types">
                                <div class="col-xl-4 col-lg-4 col-md-4">
                                    <div class="row details-inline-wrap form-box">
                                        <span class="form-box-label">{{ t.id === 1 ? "Type" : " "
                                            }}<span class="red" v-if="t.id === 1">*</span></span>
                                        <div class="form-field form-field--radiobutton">
                                            <input type="radio" :id="`type_${t.id}`" v-model="deal_service.type"
                                                :checked="deal_service.type === t.id
                                                    " name="type_id" class="type-create-deals js-edit-deal-type"
                                                :value="t.id" @change="onChangeType" />
                                            <label style="
                                                    margin-bottom: 5px;
                                                    margin-right: 12px;
                                                " :for="`type_${t.id}`">{{ t.name }}</label>
                                            <span class="error" style="left: 0" v-if="errors.type">{{ errors.type
                                                }}</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-xl-4 col-lg-4 col-md-4">
                                    <div class="form-field form-field--text" style="padding-right: 10px">
                                        <label for="amount">{{ getAmountLabel(t.id)
                                            }}<span class="red" v-if="!is_draft">*</span></label>
                                        <CurrencyInput :id="`amount_field_${t.id}`" :ref="`amount_field_${t.id}`"
                                            :disabled="t.id !== deal_service.type ||
                                                (t.id === 1 &&
                                                    deal_service.is_fluctuating_fee)
                                                " :name="`amount_field_${t.id}`" v-model="deal_service[
                                                    get_deal_service_type(t.id)
                                                ]
                                                    " @change="handleChangeAmount" :options="{
                                                    currency: 'USD',
                                                    hideCurrencySymbolOnFocus: false,
                                                    hideGroupingSeparatorOnFocus: false,
                                                    hideNegligibleDecimalDigitsOnFocus: false,
                                                }" />
                                        <!-- <input
                                            type="text"
                                            :id="`amount_field_${t.id}`"
                                            :ref="`amount_field_${t.id}`"
                                            :disabled="
                                                t.id !== deal_service.type ||
                                                deal_service.is_fluctuating_fee
                                            "
                                            :name="`amount_field_${t.id}`"
                                            :value="
                                                t.id === 1
                                                    ? deal_service.mounthly_fee
                                                    : t.id === 2
                                                    ? deal_service.full_amount
                                                    : deal_service.one_time_fee
                                            "
                                            @change="handleChangeAmount"
                                        /> -->
                                        <span class="error" style="left: 0" v-if="
                                            t.id === deal_service.type &&
                                            errors.amount
                                        ">{{ errors.amount }}</span>
                                    </div>
                                    <div class="form-field form-field--tree" v-if="t.id === 1">
                                        <label for="frequency_retainer">Frequency </label>
                                        <treeselect v-model="deal_service.frequency" id="frequency"
                                            name="frequency_retainer" :disabled="deal_service.type !== 1"
                                            :clearable="false" :multiple="false" :options="frequency_list" />
                                    </div>
                                </div>
                                <div class="col-xl-4 col-lg-4 col-md-4" v-if="t.id === 1">
                                    <div class="form-field checkbox-wrap" style="
                                            margin-bottom: 0;
                                            margin-top: 27px;
                                        ">
                                        <input :disabled="deal_service.type !== 1" v-model="deal_service.is_fluctuating_fee
                                            " type="checkbox" id="fluctuating_fee" name="fluctuating_fee" />
                                        <label for="fluctuating_fee">
                                            <i class="icon icon-checkmark"></i>
                                        </label>
                                        Fluctuating fee
                                    </div>
                                </div>
                                <div class="col-xl-4 col-lg-4 col-md-4" v-if="t.id === 2">
                                    <div class="form-field form-field--text">
                                        <label for="amount">Number of pmts<span v-if="!is_draft"
                                                class="red">*</span></label>
                                        <input type="number" :disabled="deal_service.type !== 2" id="number_of_pmts"
                                            v-model="deal_service.number_of_pmts
                                                " name="number_of_pmts" />
                                        <span class="error" style="left: 0" v-if="
                                            errors.number_of_pmts &&
                                            deal_service.type === 2
                                        ">{{ errors.number_of_pmts }}</span>
                                    </div>
                                </div>
                            </div>
                            <!-- <div class="row details-inline-wrap form-box">
                                <span class="form-box-label"
                                    >Type<span class="red">*</span></span
                                >
                                <div class="form-field form-field--radiobutton">
                                    <template v-for="t in brand_types">
                                        <input
                                            type="radio"
                                            :id="`type_${t.id}`"
                                            v-model="deal_service.type"
                                            :checked="
                                                deal_service.type === t.id
                                            "
                                            name="type_id"
                                            class="type-create-deals js-edit-deal-type"
                                            :value="t.id"
                                        />
                                        <label
                                            style="
                                                margin-bottom: 5px;
                                                margin-right: 12px;
                                            "
                                            :for="`type_${t.id}`"
                                            >{{ t.name }}</label
                                        >
                                    </template>
<span class="error" style="left: 0" v-if="errors.type">{{ errors.type }}</span>
</div>
</div> -->
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-xl-12 col-lg-12 col-md-12">
                            <div class="form-field form-field--textarea">
                                <label for="amount">Terms</label>
                                <textarea id="terms" v-model="deal_service.terms" name="terms"></textarea>
                            </div>
                        </div>
                    </div>
                    <div class="row jus-c--center">
                        <div class="col-xl-4 col-lg-4">
                            <div class="btn-wrap jus-c--center">
                                <button @click="handleSubmit" type="button" class="btn">
                                    Save
                                </button>
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-4">
                            <div class="btn-wrap jus-c--center">
                                <button @click="handleCloseModal" type="button" class="btn">
                                    Cancel
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <AddNewServiceModal v-if="isOpenNewServiceModal" :serviceOptions="services_list" :onAdd="createNewService"
            :onClose="toggleNewServiceModal" />
    </div>
</template>

<script>
import moment from "moment";
import { Datepicker } from "vanillajs-datepicker";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import AddNewServiceModal from "../../BusinessTab/modals/AddNewService.vue";
import CurrencyInput from "../../CurrencyInput";

export default {
    name: "Add_Service_To_Deal",
    components: {
        Treeselect,
        AddNewServiceModal,
        CurrencyInput,
    },
    props: {
        deal_id: {
            type: Number,
            required: true,
        },
        deal_status: {},
        brand_types: {
            type: Array,
        },
        onClose: {
            type: Function,
        },
        services: {
            type: Array,
        },
        selected_service: {
            type: Number,
        },
        updateList: {
            type: Function,
        },
        sow_list: {
            type: Array,
        },
        editId: {
            type: Number,
        },
        editData: {
            type: Object,
        },
        onUpdate: {
            type: Function,
        },
        onCreate: {
            type: Function,
        },
        agency_id: {
            type: Number,
        },
        id_created_sow: {
            type: Number,
        },
        diminishing: {
            type: [Number, Boolean],
        },

        deal_period: {
            type: [Number, String],
        },
    },
    mounted() {
        this.initDatePicker();
        this.deal_service.type = this.brand_types[0].id;
        //this.deal_service.service_id = this.selected_service;
        this.services_list = this.services;
        console.log(this.services_list)
        if (!this.editId && this.id_created_sow) {
            this.deal_service.sow_file = this.id_created_sow;
        }

        if (this.editId) {
            this.deal_service.custom_service = this.editData.custom_service;
            //this.deal_service.one_time_setup_fee =
            //this.editData.is_one_time_setup_fee;
            this.deal_service.kick_off_date =
                !this.editData.kickoff_date ||
                    this.editData.kickoff_date === "-"
                    ? null
                    : this.editData.kickoff_date;
            this.deal_service.number_of_pmts = this.editData.num_of_payments;
            //this.deal_service.one_time_setup_value =
            //this.editData.one_time_setup_fee;
            this.deal_service.terms = this.editData.terms;
            this.deal_service.type = this.editData.type.id;
            let services = [];

            if (this.editData.service[0].hasOwnProperty("id")) {
                services = this.editData.service.map((service) => {
                    if (service.id) {
                        return service.id;
                    }
                });
            }
            this.deal_service.service_id = services.length ? services : [];

            this.deal_service.sow_file = this.editData.sow.id;

            if (this.editData.type.id === 1) {
                this.deal_service.mounthly_fee = this.editData.amount;
                this.deal_service.is_fluctuating_fee =
                    Boolean(this.editData.fluctuating_fee) || false;
                this.deal_service.frequency = this.frequency_list.find(obj => {
                    return obj.id === (this.editData.hasOwnProperty("frequency_retainer") ? this.editData.frequency_retainer : 1)
                }).id;

            }
            if (this.editData.type.id === 2) {
                this.deal_service.full_amount = this.editData.amount;
            }
            if (this.editData.type.id === 3) {
                this.deal_service.one_time_fee = this.editData.amount;
            }
        }

        if (this.deal_status.name === "Draft") {
            this.is_draft = true;
        }
    },
    data() {
        return {
            deal_service: {
                service_id: [],
                kick_off_date: null,
                custom_service: "",
                full_amount: 0,
                amount: null,
                mounthly_fee: 0,
                one_time_fee: 0,
                type: null,
                number_of_pmts: null,
                //one_time_setup_fee: false,
                //one_time_setup_value: "",
                terms: "",
                sow_file: null,
                is_fluctuating_fee: false,
                frequency: 1,
            },
            errors: {
                service_id: null,
                type: null,
                amount: null,
                number_of_pmts: null,

                sow_file: null,
                custom_service: null,
            },
            services_list: [],
            is_draft: false,
            isOpenNewServiceModal: false,
            datepicker_options: {
                format: "mm/dd/yyyy",
                pickLevel: 0,
                autohide: true,
            },
            frequency_list: [
                {
                    id: 1,
                    label: "1m"
                },
                {
                    id: 12,
                    label: "1y"
                }
            ],
        };
    },
    watch: {
        "deal_service.type": function (newValue) {
            if (newValue !== 2) {
                this.deal_service.number_of_pmts = null;
            }
        },
    },
    computed: {
        sow_select_list() {

            if (this.sow_list.length) {
                return this.sow_list.map((item) => {
                    return {
                        id: item.id,
                        label: item.name,
                        isDisabled: item.isDisabled,
                    };
                });
            }

            return []
        },
        calculated_diminishing_date() {
            if (this.deal_service.kick_off_date) {
                let date = new Date(this.deal_service.kick_off_date);
                let now = moment(date).format();
                now = moment(now)
                    .add(Number(this.deal_period), "M")
                    .format("MM/DD/YYYY");

                return now;
            }

            return "";
        },
    },
    methods: {
        onChangeCheckbox(e) {
            this.deal_service.one_time_setup_fee = e.target.checked;
        },

        handleSubmit() {
            this.validateFields();
            let self = this;

            if (
                this.errors.amount ||
                this.errors.service_id ||
                this.errors.type ||
                this.errors.sow_file ||
                (this.errors.number_of_pmts && this.deal_service.type === 2) ||
                this.errors.custom_service
            ) {
                return;
            }

            if (this.editId) {
                this.onUpdate({
                    id: this.editId,
                    deal_id: this.deal_id,
                    service_id: this.deal_service.service_id,
                    kickoff_date: this.deal_service.kick_off_date
                        ? this.deal_service.kick_off_date
                        : null,
                    custom_service: this.deal_service.custom_service,
                    amount:
                        this.deal_service.type === 1
                            ? this.deal_service.mounthly_fee
                            : this.deal_service.type === 2
                                ? this.deal_service.full_amount
                                : this.deal_service.one_time_fee,
                    type_id: this.deal_service.type,
                    num_of_payments:
                        this.deal_service.number_of_pmts === "-"
                            ? 0
                            : this.deal_service.number_of_pmts,
                    one_time_setup_fee: this.deal_service.one_time_setup_fee,
                    one_time_setup_value:
                        this.deal_service.one_time_setup_value,
                    terms: this.deal_service.terms,
                    sow_id: this.deal_service.sow_file,
                    fluctuating_fee: this.deal_service.is_fluctuating_fee,
                    frequency_retainer: this.deal_service.hasOwnProperty("frequency") ? this.deal_service.frequency : 1,
                });
                return;
            }

            switch (this.deal_service.type) {
                case 1:
                    this.deal_service.amount = this.deal_service.mounthly_fee;
                    break;
                case 2:
                    this.deal_service.amount = this.deal_service.full_amount;
                    break;
                case 3:
                    this.deal_service.amount = this.deal_service.one_time_fee;
                    break;
            }

            this.onCreate({
                deal_id: this.deal_id,
                service_id: this.deal_service.service_id,
                kickoff_date: this.deal_service.kick_off_date,
                custom_service: this.deal_service.custom_service,
                amount: this.deal_service.amount,
                type_id: this.deal_service.type,
                num_of_payments: this.deal_service.number_of_pmts,
                one_time_setup_fee: this.deal_service.one_time_setup_fee,
                one_time_setup_value: this.deal_service.one_time_setup_value,
                terms: this.deal_service.terms,
                sow_id: this.deal_service.sow_file,
                fluctuating_fee: this.deal_service.is_fluctuating_fee,
                frequency_retainer: this.deal_service.hasOwnProperty("frequency") ? this.deal_service.frequency : 1
            });
        },

        // updateList(deal_line_items) {
        //     this.$emit("updateList", deal_line_items);
        // },

        handleCloseModal() {
            //this.clear();
            this.onClose();
        },

        validateFields() {
            this.errors.service_id = null;
            this.errors.type = null;
            this.errors.amount = null;
            this.errors.number_of_pmts = null;
            this.errors.sow_file = null;
            this.errors.custom_service = null;

            if (
                (!this.deal_service.service_id ||
                    this.deal_service.service_id.length <= 0) &&
                !this.deal_service.custom_service
            ) {
                this.errors.custom_service = "Choose a service or enter custom";
            }

            // if (
            //     (!this.deal_service.service_id ||
            //         this.deal_service.service_id.length <= 0) &&
            //     !this.deal_service.custom_service
            // ) {
            //     this.errors.service_id = "Required";
            // }
            if (!this.deal_service.type) {
                this.errors.type = "Required";
            }
            // if (!this.deal_service.amount && !this.is_draft) {
            //     this.errors.amount = "Required";
            // }
            if (
                (this.deal_service.type === 2 &&
                    !this.deal_service.full_amount) ||
                (this.deal_service.full_amount &&
                    (this.deal_service.full_amount <= 0 ||
                        !/^[+-]?(\d*\.)?\d+$/.test(this.deal_service.full_amount)))
            ) {
                this.errors.amount = "Invalid value";
            }
            if (
                this.deal_service.type === 1 &&
                !this.deal_service.is_fluctuating_fee &&
                (this.deal_service.mounthly_fee <= 0 ||
                    !/^[+-]?(\d*\.)?\d+$/.test(this.deal_service.mounthly_fee))
            ) {
                this.errors.amount = "Invalid value";
            }
            if (
                this.deal_service.type === 3 &&
                (this.deal_service.one_time_fee <= 0 ||
                    !/^[+-]?(\d*\.)?\d+$/.test(this.deal_service.one_time_fee))
            ) {
                this.errors.amount = "Invalid value";
            }
            if (!this.is_draft && !this.deal_service.number_of_pmts) {
                this.errors.number_of_pmts = "Required";
            }

            if (
                !this.is_draft &&
                this.deal_service.number_of_pmts &&
                (this.deal_service.number_of_pmts < 0 ||
                    !/^[+-]?(\d*\.)?\d+$/.test(this.deal_service.number_of_pmts))
            ) {
                this.errors.number_of_pmts = "Invalid value";
            }

            if (!this.deal_service.sow_file) {
                this.errors.sow_file = "Required";
            }
        },

        clear() {
            this.deal_service.service_id = [];
            this.deal_service.kick_off_date = null;
            this.deal_service.custom_service = "";
            this.deal_service.amount = "";
            this.deal_service.type = null;
            this.deal_service.number_of_pmts = 0;
            //one_time_setup_fee: false;
            //one_time_setup_value: "";
            this.deal_service.terms = "";
            this.deal_service.sow_file = null;
        },

        initDatePicker() {
            const node__datepicker = this.$refs.datepicker;

            if (!node__datepicker) {
                return;
            }

            let datepicker = null;
            const input = node__datepicker.querySelector("input");
            const button = node__datepicker.querySelector("button");

            if (input) {
                datepicker = new Datepicker(input, this.datepicker_options);
            }

            if (button) {
                button.addEventListener("click", () => {
                    if (!datepicker.active) {
                        datepicker.show();
                    }
                });
            }
        },

        onChangeDatePicker(e) {
            const date = e.target.value;

            if (date) {
                console.log(date);
                this.deal_service.kick_off_date = date;
            }
        },

        createNewService(params) {
            axios
                .post("/service/create", params)
                .then((res) => {
                    if (res.data) {
                        this.fetchAllServicesByAgencyId(this.agency_id);
                        this.toggleNewServiceModal();
                    }
                })
                .catch((err) => {
                    console.error(err);
                });
        },

        toggleNewServiceModal() {
            this.isOpenNewServiceModal = !this.isOpenNewServiceModal;
        },

        fetchAllServicesByAgencyId(id) {
            if (id) {
                axios
                    .post("/agencies/business/getServicesTree", {
                        agency_id: id,
                    })
                    .then((res) => {
                        this.services_list = res.data;
                    })
                    .catch((err) => console.log(err));
            }
        },

        getAmountLabel(id) {
            switch (id) {
                case 1:
                    return "Monthly fee";
                case 2:
                    return "Full Amount";
                case 3:
                    return "One-time fee";
                default:
                    return "Monthly fee";
            }
        },

        handleChangeAmount(e) {
            const value = e.target.value;
            if (value) {
                switch (this.deal_service.type) {
                    case 1:
                        this.deal_service.mounthly_fee = value;
                        break;
                    case 2:
                        this.deal_service.full_amount = value;
                        break;
                    case 3:
                        this.deal_service.one_time_fee = value;
                        break;
                }
            }
        },

        onChangeType() {
            this.errors.amount = null;
            switch (this.deal_service.type) {
                case 1:
                    this.deal_service.full_amount = 0;
                    this.deal_service.one_time_fee = 0;
                    break;
                case 2:
                    this.deal_service.one_time_fee = 0;
                    this.deal_service.mounthly_fee = 0;
                    break;
                case 3:
                    this.deal_service.mounthly_fee = 0;
                    this.deal_service.full_amount = 0;
                    break;
            }
        },

        get_deal_service_type(id = null) {
            if (!id) {
                return;
            }

            switch (id) {
                case 1:
                    return "mounthly_fee";
                case 2:
                    return "full_amount";
                case 3:
                    return "one_time_fee";
                default:
                    return;
            }
        },
    },
};
</script>
